/*
AI Variant Manager
负责:
- Shopify Variant查询
- Variant状态管理
- 无刷新切换
- UI同步
- 浏览器返回状态恢复
- Add to cart价格同步
*/

window.AI_VARIANT_MANAGER=window.AI_VARIANT_MANAGER||{};

(function(){

"use strict";


const Manager={


state:{
option1:"",
option2:"",
option3:"",
option4:""
},


variants:[],


init:function(){

this.variants=window.productVariantsJSON||[];

const defaultId=window.DEFAULT_VARIANT_ID;

let variant=null;


if(defaultId){

variant=this.variants.find(
v=>v.id===Number(defaultId)
);

}


if(!variant){

variant=this.variants[0];

}


if(variant){

this.syncFromVariantObject(variant);

this.emitInit(variant);

}



console.log(
"[AI Variant Manager Ready]",
this.state
);


},



syncFromVariantObject:function(variant){

this.state={

option1:variant.option1||"",

option2:variant.option2||"",

option3:variant.option3||"",

option4:variant.option4||""

};

},





select:function(options={}){


this.state={

...this.state,

...options

};



const variant=this.findVariant(
this.state
);



if(!variant){

console.error(
"[AI Variant] Variant not found",
this.state
);

return false;

}



this.applyVariant(
variant
);



return true;


},




findVariant:function(state){


return this.variants.find(
variant=>{


if(
state.option1 &&
variant.option1!==state.option1
){

return false;

}



if(
state.option2 &&
variant.option2!==state.option2
){

return false;

}



if(
state.option3 &&
variant.option3!==state.option3
){

return false;

}



if(
state.option4 &&
variant.option4!==state.option4
){

return false;

}



return true;


}
);


},




applyVariant:function(variant){


const input=document.querySelector(
"input.product-variant-id"
);



if(input){

input.value=variant.id;


input.dispatchEvent(
new Event(
"change",
{
bubbles:true
}
)
);


}





[
variant.option1,
variant.option2,
variant.option3,
variant.option4

].forEach(value=>{


if(!value){
return;
}



const radio=document.querySelector(
`variant-selects input[value="${value}"]`
);



if(radio){

radio.checked=true;

}



});





this.syncFromVariantObject(
variant
);



this.updatePrice(
variant
);



this.emitChange(
variant
);



},





updatePrice:function(variant){


const money=
`$${(variant.price/100).toFixed(2)}`;



const price=document.querySelector(
".buckscc-money"
);



if(price){

price.innerText=money;

}




this.updateCartButtonPrice(
money
);



},





/*
同步 Shopify 当前价格到加购按钮
*/

updateCartButtonPrice:function(price){


if(!price){

return;

}



document
.querySelectorAll(
".product-form__submit"
)
.forEach(btn=>{


const span = btn.querySelector("span");


if(span){

span.innerText =
`Add to cart - ${price}`;

}


});


},



emitChange:function(variant){


window.dispatchEvent(
new CustomEvent(
"ai:variant-change",
{
detail:{
variant,
state:this.state
}
}
)
);


},





emitInit:function(variant){


window.dispatchEvent(
new CustomEvent(
"ai:variant-init",
{
detail:{
variant,
state:this.state
}
}
)
);


}



};




window.AI_VARIANT_MANAGER=Manager;



document.addEventListener(
"DOMContentLoaded",
function(){

Manager.init();

});





window.addEventListener(
"popstate",
function(){

location.reload();

});



window.addEventListener(
"pageshow",
function(event){


if(event.persisted){

location.reload();

}


});




})();